import React, { Component } from "react";
import Http from "../../../Http";
import Pdf from '../../../components/pdfViewer';
import { Button, CircularProgress, TextField, Chip, Checkbox, FormControlLabel, Icon } from "@material-ui/core";
import Snackbar from "../../../components/alert/Snackbar";

export default class EnviarFacturaEmail extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // PDF & Files state
      pdfURL: null,
      anexoURL: null,
      xmlText: "",
      mailLoading: false,
      loadingpdf: true,
      loadingXml: false,
      loadingAnexo: false,
      sbOpen: false,
      sbMsg: "",
      filename: "",
      loadingButton: false,

      // Custom email flow state
      loadingInfo: true,
      emails: [],
      newEmail: "",
      subject: "Factura",
      body: "",
      activePreviewTab: "pdf",
      selectedDocs: {
        pdf: true,
        xml: true,
        anexo: false
      },
      docAvailability: {
        pdf: false,
        xml: false,
        anexo: false
      },
      folioFiscal: null
    };
  }

  async componentDidMount() {
    const { factura } = this.props;
    const initialFFO = factura ? (factura.FFO || null) : null;
    this.setState({
        factura,
        folioFiscal: initialFFO,
        filename: `F${factura.tipo === 1 ? "MTY" : "CYC"}${factura.tipo_cons}`,
      },
      () => {
        this.getPDF();
        this.getEmailInfo();
      }
    );
  }

  // Safe helper to parse JSON from an ArrayBuffer or TypedArray view only if it contains JSON text
  tryParseJSON = (buffer) => {
    try {
      if (!buffer) return null;
      
      // Convert buffer safely to Uint8Array
      let uint8 = null;
      if (buffer instanceof ArrayBuffer) {
        uint8 = new Uint8Array(buffer);
      } else if (ArrayBuffer.isView(buffer)) {
        uint8 = new Uint8Array(buffer.buffer, buffer.byteOffset, buffer.byteLength);
      } else {
        uint8 = new Uint8Array(buffer);
      }

      if (!uint8 || uint8.length === 0) return null;
      
      // Read first 100 bytes to check if it begins with JSON delimiters '{' or '['
      const previewLength = Math.min(uint8.length, 100);
      let previewStr = "";
      for (let i = 0; i < previewLength; i++) {
        previewStr += String.fromCharCode(uint8[i]);
      }
      previewStr = previewStr.trim();
      
      if (previewStr.startsWith('{') || previewStr.startsWith('[')) {
        let fullStr = "";
        const chunkSize = 65536;
        for (let i = 0; i < uint8.length; i += chunkSize) {
          fullStr += String.fromCharCode.apply(null, uint8.subarray(i, i + chunkSize));
        }
        return JSON.parse(fullStr);
      }
    } catch (e) {
      console.log("Error parsing response JSON:", e);
    }
    return null;
  };

  // Converts any buffer (ArrayBuffer or View) to a string safely using chunked decode
  bufferToString = (buffer) => {
    if (!buffer) return "";
    try {
      let uint8 = null;
      if (buffer instanceof ArrayBuffer) {
        uint8 = new Uint8Array(buffer);
      } else if (ArrayBuffer.isView(buffer)) {
        uint8 = new Uint8Array(buffer.buffer, buffer.byteOffset, buffer.byteLength);
      } else {
        uint8 = new Uint8Array(buffer);
      }
      
      let str = "";
      const chunkSize = 65536;
      for (let i = 0; i < uint8.length; i += chunkSize) {
        str += String.fromCharCode.apply(null, uint8.subarray(i, i + chunkSize));
      }
      return str;
    } catch (e) {
      console.error("Error converting buffer to string:", e);
    }
    return "";
  };

  getEmailInfo = async () => {
    const { factura } = this.props;
    try {
      let res = await Http.get(`facturacion/${factura.id}/email-info`);
      if (!res.error && res.data) {
        const fetchedFFO = res.data.factura ? res.data.factura.FFO : null;
        this.setState({
          emails: res.data.emails || [],
          body: res.data.defaultBody || "",
          docAvailability: res.data.files || { pdf: false, xml: false, anexo: false },
          selectedDocs: {
            pdf: res.data.files ? res.data.files.pdf : true,
            xml: res.data.files ? res.data.files.xml : true,
            anexo: this.props.credito // Default anexo check for credit invoices
          },
          folioFiscal: fetchedFFO || this.state.folioFiscal || (factura ? factura.FFO : null),
          loadingInfo: false
        });
      } else {
        this.setState({ loadingInfo: false });
      }
    } catch (error) {
      console.log(error);
      this.setState({ loadingInfo: false });
    }
  };

  getPDF = async () => {
    const { factura } = this.props;
    const Resp = await Http.post(`facturacion/file`, { type: "pdf", factura_id: factura.id }, true, "arraybuffer");
    const response = this.tryParseJSON(Resp);
    if (response && response.error) {
      this.setState({
        loadingpdf: false,
        sbOpen: true,
        sbMsg: response.errMsg,
      });
      Snackbar(response.errMsg || "Error al obtener PDF");
    } else {
      const blob = new Blob([Resp], { type: "application/pdf" });
      this.setState({
        loadingpdf: false,
        pdfURL: URL.createObjectURL(blob),
        docAvailability: {
          ...this.state.docAvailability,
          pdf: true
        }
      });
    }
  };

  loadXMLPreview = async () => {
    const { xmlText } = this.state;
    this.setState({ activePreviewTab: 'xml' });
    if (!xmlText) {
      this.setState({ loadingXml: true });
      try {
        const { factura } = this.props;
        const Resp = await Http.post("facturacion/file", { factura_id: factura.id, type: "xml-timbrado" }, true, "arraybuffer");
        const response = this.tryParseJSON(Resp);
        if (response && response.error) {
          Snackbar(response.errMsg || "Error al obtener XML");
          this.setState({ loadingXml: false });
        } else {
          this.setState({ xmlText: this.bufferToString(Resp), loadingXml: false });
        }
      } catch (error) {
        console.log(error);
        this.setState({ loadingXml: false });
      }
    }
  };

  loadAnexoPreview = async () => {
    const { anexoURL } = this.state;
    this.setState({ activePreviewTab: 'anexo' });
    if (!anexoURL) {
      this.setState({ loadingAnexo: true });
      try {
        const { factura } = this.props;
        const Resp = await Http.post("facturacion/file", { factura_id: factura.id, type: "anexo" }, true, "arraybuffer");
        const response = this.tryParseJSON(Resp);
        if (response && response.error) {
          Snackbar(response.errMsg || "Error al obtener Anexo");
          this.setState({ loadingAnexo: false });
        } else {
          const blob = new Blob([Resp], { type: "application/pdf" });
          this.setState({ anexoURL: URL.createObjectURL(blob), loadingAnexo: false });
        }
      } catch (error) {
        console.log(error);
        this.setState({ loadingAnexo: false });
      }
    }
  };

  handleAddEmail = () => {
    const { newEmail, emails } = this.state;
    const cleanEmail = newEmail.trim();
    if (!cleanEmail) return;

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(cleanEmail)) {
      Snackbar("Por favor ingresa un correo válido");
      return;
    }

    if (emails.includes(cleanEmail)) {
      Snackbar("Este correo ya está en la lista");
      return;
    }

    this.setState({
      emails: [...emails, cleanEmail],
      newEmail: ""
    });
  };

  handleRemoveEmail = (emailToRemove) => {
    this.setState({
      emails: this.state.emails.filter(e => e !== emailToRemove)
    });
  };

  handleDocCheckboxChange = (docType, checked) => {
    this.setState({
      selectedDocs: {
        ...this.state.selectedDocs,
        [docType]: checked
      }
    });
  };

  handledownloadPdf = () => {
    const { pdfURL, filename } = this.state;
    this.setState({ loadingButton: true });
    let namepdf = `${filename}.pdf`;
    const a = document.createElement("a");
    a.style.display = "none";
    a.href = `${pdfURL}`;
    a.download = namepdf;
    document.body.appendChild(a);
    a.click();
    this.setState({ loadingButton: false });
  };

  hasFolioFiscal = () => {
    const { folioFiscal, factura } = this.state;
    const currentFactura = factura || this.props.factura || {};
    if (folioFiscal && typeof folioFiscal === 'string' && folioFiscal.trim() !== '') {
      return true;
    }
    if (currentFactura.FFO && typeof currentFactura.FFO === 'string' && currentFactura.FFO.trim() !== '') {
      return true;
    }
    if (currentFactura.timbrada && currentFactura.timbrada !== 'No') {
      return true;
    }
    return false;
  };

  handleEmail = async () => {
    const { emails, subject, body, selectedDocs } = this.state;
    const { factura } = this.props;

    if (!this.hasFolioFiscal()) {
      Snackbar("No se puede enviar una factura sin Folio Fiscal");
      return;
    }

    if (emails.length === 0) {
      Snackbar("Por favor agrega al menos un correo destinatario");
      return;
    }

    this.setState({ mailLoading: true });
    try {
      let res = await Http.post(`facturacion/email`, {
        ...factura,
        customMails: emails,
        customSubject: subject,
        customBody: body,
        selectedDocs: selectedDocs
      });
      if (!res.error) {
        Snackbar("Correos enviados");
      } else {
        Snackbar(res.errMsg || "Error al reenviar correo");
      }
    } catch (error) {
      console.log(error);
      Snackbar("Error al reenviar correo");
    }
    this.setState({ mailLoading: false });
  };

  handledownloadFile = async (type) => {
    const { factura, filename } = this.state;
    this.setState({ loadingButton: true });
    const Resp = await Http.post("facturacion/file", { factura_id: factura.id, type }, true, "arraybuffer");
    const response = this.tryParseJSON(Resp);
    if (response && response.error) {
      this.setState({
        loadingpdf: false,
        sbOpen: true,
        sbMsg: response.errMsg,
      });
      Snackbar(response.errMsg || "Error al descargar archivo");
    } else {
      let xmlfile = `XML_${filename}.xml`;
      const blob = new Blob([Resp], { type: "application/xml" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.style.display = "none";
      a.href = url;
      a.download = xmlfile;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
    }
    this.setState({ loadingButton: false });
  };

  handledownloadAnexo = async () => {
    const { factura, filename } = this.state;
    this.setState({ loadingButton: true });
    const Resp = await Http.post("facturacion/file", { factura_id: factura.id, type: "anexo" }, true, "arraybuffer");
    if (Resp) {
      let anexofile = `Anexo_${filename}`;
      const blob = new Blob([Resp], { type: "application/pdf" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.style.display = "none";
      a.href = url;
      a.download = `${anexofile}.pdf`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
    }
    this.setState({ loadingButton: false });
  };

  handleDownloadFiles = async () => {
    const { credito } = this.props;
    await this.handledownloadPdf();
    await this.handledownloadFile("xml-timbrado");
    if (credito || this.state.docAvailability.anexo) {
      await this.handledownloadAnexo();
    }
  };

  handleRegenPDF = async () => {
    const { factura } = this.props;
    this.setState({ loadingpdf: true, pdfURL: null });
    const Resp = await Http.post(`facturacion/regen`, { type: "pdf", factura_id: factura.id }, true, "arraybuffer");
    const response = this.tryParseJSON(Resp);
    if (response && response.error) {
      this.setState({
        loadingpdf: false,
        sbOpen: true,
        sbMsg: response.errMsg,
      });
      Snackbar(response.errMsg || "Error al regenerar PDF");
    } else {
      const blob = new Blob([Resp], { type: "application/pdf" });
      this.setState({
        loadingpdf: false,
        pdfURL: URL.createObjectURL(blob),
        activePreviewTab: "pdf"
      });
    }
  };

  componentWillUnmount() {
    const { pdfURL, anexoURL } = this.state;
    if (pdfURL) window.URL.revokeObjectURL(pdfURL);
    if (anexoURL) window.URL.revokeObjectURL(anexoURL);
  }

  render() {
    const {
      pdfURL,
      anexoURL,
      xmlText,
      loadingpdf,
      loadingXml,
      loadingAnexo,
      loadingButton,
      mailLoading,
      emails,
      newEmail,
      subject,
      body,
      activePreviewTab,
      selectedDocs,
      docAvailability,
      filename,
      loadingInfo
    } = this.state;
    const { credito } = this.props;
    const hasFolioFiscal = this.hasFolioFiscal();
    return (
      <div className="flex flex-col gap-6 p-4 bg-gray-50 rounded-xl reenviar-factura-wrapper">
        <style>{`
          /* Desktop layout (>= 1200px) */
          @media (min-width: 1200px) {
            .reenviar-factura-wrapper {
              flex-direction: row !important;
              height: 680px !important;
              max-height: 85vh !important;
              overflow: hidden !important;
            }
            .reenviar-factura-wrapper .preview-panel-col {
              flex: 1 !important;
              height: 100% !important;
              max-width: 1000px !important;
              display: flex !important;
              flex-direction: column !important;
              overflow: hidden !important;
            }
            .reenviar-factura-wrapper .preview-content-area {
              flex: 1 !important;
              height: 100% !important;
              min-height: 0 !important;
            }
            .reenviar-factura-wrapper .settings-panel-col {
              width: 440px !important;
              height: 100% !important;
              overflow-y: auto !important;
              display: flex !important;
              flex-direction: column !important;
              justify-content: space-between !important;
              gap: 16px !important;
              padding-right: 6px !important;
            }
            /* Hide the Dialog scrollbars */
            .MuiDialogContent-root:has(.reenviar-factura-wrapper) {
              overflow: hidden !important;
              padding: 12px 24px !important;
            }
          }

          /* Tablet/Mobile layout (< 1200px) */
          @media (max-width: 1199px) {
            .reenviar-factura-wrapper {
              flex-direction: column !important;
              height: auto !important;
              max-height: none !important;
              overflow: visible !important;
            }
            .reenviar-factura-wrapper .preview-panel-col {
              width: 100% !important;
              height: auto !important;
              margin-bottom: 16px !important;
            }
            .reenviar-factura-wrapper .preview-content-area {
              height: 480px !important;
            }
            .reenviar-factura-wrapper .settings-panel-col {
              width: 100% !important;
              height: auto !important;
              overflow: visible !important;
            }
          }

          .reenviar-factura-wrapper .pdf-viewer-parent {
            width: 100% !important;
            height: 100% !important;
            min-width: 0 !important;
            display: flex !important;
            flex-direction: column !important;
          }
          .reenviar-factura-wrapper .pdf-viewer-parent > div {
            width: 100% !important;
            height: 100% !important;
            min-width: 0 !important;
            display: flex !important;
            flex-direction: column !important;
          }
          .reenviar-factura-wrapper #canvas_container {
            width: 100% !important;
            max-width: 100% !important;
            min-width: 0 !important;
            flex: 1 !important;
            height: auto !important;
            background: #f3f4f6 !important;
            border: none !important;
            overflow: auto !important;
            padding: 16px 0 !important;
            text-align: center !important;
          }
          .reenviar-factura-wrapper canvas {
            margin: 0 auto !important;
            display: block !important;
            box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1) !important;
            border-radius: 6px !important;
            border: 1px solid #e5e7eb !important;
            background: #ffffff !important;
          }
        `}</style>
        {/* Left Side: Document Preview Panel */}
        <div className="preview-panel-col bg-white p-4 rounded-xl shadow-sm border border-gray-100 flex flex-col">
          {/* Preview Header / Tabs */}
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between border-b border-gray-100 pb-3 mb-4 gap-2">
            <div className="flex items-center gap-2">
              <Icon className="text-indigo-600">visibility</Icon>
              <span className="font-semibold text-gray-800 text-lg">Vista Previa</span>
            </div>
            
            {/* Tabs */}
            <div className="flex bg-gray-100 p-1 rounded-lg gap-1 self-stretch sm:self-auto">
              <button
                type="button"
                onClick={() => this.setState({ activePreviewTab: 'pdf' })}
                className={`flex-1 sm:flex-none px-3 py-1.5 text-xs font-semibold rounded-md transition-all ${
                  activePreviewTab === 'pdf'
                    ? 'bg-white text-indigo-600 shadow-sm'
                    : 'text-gray-600 hover:text-gray-900'
                }`}
              >
                Factura (PDF)
              </button>
              <button
                type="button"
                onClick={this.loadXMLPreview}
                className={`flex-1 sm:flex-none px-3 py-1.5 text-xs font-semibold rounded-md transition-all ${
                  activePreviewTab === 'xml'
                    ? 'bg-white text-indigo-600 shadow-sm'
                    : 'text-gray-600 hover:text-gray-900'
                }`}
              >
                CFDI (XML)
              </button>
              {(credito || docAvailability.anexo) && (
                <button
                  type="button"
                  onClick={this.loadAnexoPreview}
                  className={`flex-1 sm:flex-none px-3 py-1.5 text-xs font-semibold rounded-md transition-all ${
                    activePreviewTab === 'anexo'
                      ? 'bg-white text-indigo-600 shadow-sm'
                      : 'text-gray-600 hover:text-gray-900'
                  }`}
                >
                  Anexo (PDF)
                </button>
              )}
            </div>
          </div>

          {/* Preview Content Area */}
          <div className="preview-content-area w-full flex items-stretch justify-center bg-gray-100 rounded-lg overflow-hidden relative border border-gray-200">
            {activePreviewTab === 'pdf' && (
              loadingpdf ? (
                <div className="flex flex-col items-center justify-center gap-3 w-full h-full">
                  <CircularProgress size={40} className="text-indigo-600" />
                  <span className="text-sm text-gray-500 font-medium">Cargando PDF...</span>
                </div>
              ) : pdfURL ? (
                <div className="w-full h-full pdf-viewer-parent">
                  <Pdf minWidth="100%" pdfUrl={pdfURL} />
                </div>
              ) : (
                <span className="text-gray-400 self-center">PDF no disponible</span>
              )
            )}

            {activePreviewTab === 'xml' && (
              loadingXml ? (
                <div className="flex flex-col items-center justify-center gap-3 w-full h-full">
                  <CircularProgress size={40} className="text-indigo-600" />
                  <span className="text-sm text-gray-500 font-medium">Obteniendo XML...</span>
                </div>
              ) : xmlText ? (
                <div className="w-full h-full p-4 bg-gray-900 text-green-400 font-mono text-xs overflow-auto text-left whitespace-pre-wrap select-all leading-relaxed rounded-lg">
                  {xmlText}
                </div>
              ) : (
                <span className="text-gray-400 self-center">XML no disponible</span>
              )
            )}

            {activePreviewTab === 'anexo' && (
              loadingAnexo ? (
                <div className="flex flex-col items-center justify-center gap-3 w-full h-full">
                  <CircularProgress size={40} className="text-indigo-600" />
                  <span className="text-sm text-gray-500 font-medium">Obteniendo Anexo...</span>
                </div>
              ) : anexoURL ? (
                <div className="w-full h-full pdf-viewer-parent">
                  <Pdf minWidth="100%" pdfUrl={anexoURL} />
                </div>
              ) : (
                <span className="text-gray-400 self-center">Anexo no disponible o no generado</span>
              )
            )}
          </div>
        </div>        {/* Right Side: Email Settings & Actions */}
        <div className="settings-panel-col bg-white p-3 rounded-xl shadow-sm border border-gray-100 flex flex-col justify-between gap-3">
          {/* Config Content */}
          <div className="flex flex-col gap-3">
            {/* Header Info */}
            <div>
              <div className="text-xs text-gray-400 font-bold tracking-wider uppercase mb-0.5">Reenviar Factura</div>
              <h3 className="font-extrabold text-gray-800 text-xl flex items-center gap-2">
                {filename || "Cargando..."}
              </h3>
            </div>

            <hr className="border-gray-100 my-0 border-t" style={{ margin: '0' }} />

            {/* Recipients Selection */}
            <div className="flex flex-col gap-1.5">
              <label className="text-xs font-bold text-gray-600 uppercase tracking-wider flex items-center gap-1">
                <Icon className="text-sm">people</Icon> Destinatarios
              </label>
              
              {/* Email Chips */}
              <div className="flex flex-wrap gap-1 min-h-[32px] p-1.5 bg-gray-50 rounded-lg border border-gray-200">
                {emails.length === 0 ? (
                  <span className="text-xs text-gray-400 italic self-center pl-2">No hay correos destinatarios</span>
                ) : (
                  emails.map((email, idx) => (
                    <Chip
                      key={idx}
                      label={email}
                      onDelete={() => this.handleRemoveEmail(email)}
                      className="bg-indigo-50 text-indigo-700 font-semibold text-xs border border-indigo-100 hover:bg-indigo-100 transition-colors"
                      size="small"
                    />
                  ))
                )}
              </div>

              {/* Add Email input */}
              <div className="flex gap-1.5 mt-0.5">
                <TextField
                  variant="outlined"
                  size="small"
                  placeholder="nuevo@correo.com"
                  value={newEmail}
                  onChange={(e) => this.setState({ newEmail: e.target.value })}
                  onKeyPress={(e) => {
                     if (e.key === 'Enter') {
                       e.preventDefault();
                       this.handleAddEmail();
                     }
                  }}
                  fullWidth
                  className="bg-white"
                />
                <Button
                  variant="contained"
                  color="primary"
                  onClick={this.handleAddEmail}
                  className="bg-indigo-600 hover:bg-indigo-700 text-white min-w-[45px] shadow-sm px-0"
                >
                  <Icon>add</Icon>
                </Button>
              </div>
            </div>

            {/* Document Checkboxes */}
            <div className="flex flex-col gap-1.5">
              <label className="text-xs font-bold text-gray-600 uppercase tracking-wider flex items-center gap-1">
                <Icon className="text-sm">folder</Icon> Adjuntos en el correo
              </label>
              <div className="grid grid-cols-3 gap-1 bg-gray-50 p-1.5 rounded-lg border border-gray-200">
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={selectedDocs.pdf}
                      onChange={(e) => this.handleDocCheckboxChange('pdf', e.target.checked)}
                      color="primary"
                      disabled={!docAvailability.pdf && !loadingpdf}
                    />
                  }
                  label={
                    <span className="flex items-center gap-1 text-xs font-semibold text-gray-700 select-none">
                      <Icon className="text-red-500 text-sm">picture_as_pdf</Icon> PDF
                    </span>
                  }
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={selectedDocs.xml}
                      onChange={(e) => this.handleDocCheckboxChange('xml', e.target.checked)}
                      color="primary"
                      disabled={!docAvailability.xml}
                    />
                  }
                  label={
                    <span className="flex items-center gap-1 text-xs font-semibold text-gray-700 select-none">
                      <Icon className="text-yellow-600 text-sm">code</Icon> XML
                    </span>
                  }
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={selectedDocs.anexo}
                      onChange={(e) => this.handleDocCheckboxChange('anexo', e.target.checked)}
                      color="primary"
                    />
                  }
                  label={
                    <span className="flex items-center gap-1 text-xs font-semibold text-gray-700 select-none">
                      <Icon className="text-blue-500 text-sm">attachment</Icon> Anexo
                    </span>
                  }
                />
              </div>
            </div>

            {/* Subject and Body */}
            <div className="flex flex-col gap-2">
              <TextField
                label="Asunto del Correo"
                variant="outlined"
                size="small"
                value={subject}
                onChange={(e) => this.setState({ subject: e.target.value })}
                fullWidth
                className="bg-white"
              />
              <TextField
                label="Mensaje (Cuerpo)"
                variant="outlined"
                multiline
                minRows={3}
                value={body}
                onChange={(e) => this.setState({ body: e.target.value })}
                fullWidth
                className="bg-white"
              />
            </div>
          </div>

          {/* Primary and Secondary Actions */}
          <div className="flex flex-col gap-2 mt-2">
            {!hasFolioFiscal && !loadingInfo && (
              <div className="p-3 bg-red-50 border border-red-200 rounded-lg flex items-center gap-2 text-red-700 text-xs font-semibold">
                <Icon className="text-red-500 text-base">error_outline</Icon>
                <span>No se puede enviar esta factura por correo porque no cuenta con Folio Fiscal.</span>
              </div>
            )}
            {/* Primary Send Button */}
            <Button
              variant="contained"
              onClick={this.handleEmail}
              disabled={mailLoading || emails.length === 0 || !hasFolioFiscal}
              className="w-full py-2.5 text-white bg-gradient-to-r from-indigo-600 to-blue-600 hover:from-indigo-700 hover:to-blue-700 rounded-lg shadow-md font-bold transition-all transform hover:-translate-y-0.5 active:translate-y-0 disabled:opacity-50"
            >
              {mailLoading ? (
                <div className="flex items-center justify-center gap-2">
                  <CircularProgress size={20} color="inherit" />
                  <span>Enviando...</span>
                </div>
              ) : (
                <div className="flex items-center justify-center gap-2">
                  <Icon className="text-white">send</Icon>
                  <span>Reenviar correo</span>
                </div>
              )}
            </Button>

            <hr className="border-gray-100 my-1" />

            {/* Secondary Actions: Downloads & PDF Regen */}
            <div className="grid grid-cols-2 gap-2">
              <Button
                variant="outlined"
                onClick={this.handledownloadPdf}
                disabled={loadingButton || !pdfURL}
                size="small"
                className="text-gray-700 border-gray-300 hover:bg-gray-50 flex gap-1.5 items-center justify-center normal-case text-xs font-semibold py-1.5"
              >
                <Icon className="text-sm">cloud_download</Icon> PDF
              </Button>
              <Button
                variant="outlined"
                onClick={this.handleRegenPDF}
                disabled={loadingButton}
                size="small"
                className="text-gray-700 border-gray-300 hover:bg-gray-50 flex gap-1.5 items-center justify-center normal-case text-xs font-semibold py-1.5"
              >
                <Icon className="text-sm">refresh</Icon> Regenerar PDF
              </Button>
              <Button
                variant="outlined"
                onClick={() => this.handledownloadFile("xml-timbrado")}
                disabled={loadingButton || !docAvailability.xml}
                size="small"
                className="text-gray-700 border-gray-300 hover:bg-gray-50 flex gap-1.5 items-center justify-center normal-case text-xs font-semibold py-1.5"
              >
                <Icon className="text-sm">code</Icon> XML
              </Button>
              {(credito || docAvailability.anexo) && (
                <Button
                  variant="outlined"
                  onClick={this.handledownloadAnexo}
                  disabled={loadingButton}
                  size="small"
                  className="text-gray-700 border-gray-300 hover:bg-gray-50 flex gap-1.5 items-center justify-center normal-case text-xs font-semibold py-1.5"
                >
                  <Icon className="text-sm">attachment</Icon> Anexo
                </Button>
              )}
              <Button
                variant="outlined"
                onClick={this.handleDownloadFiles}
                size="small"
                className="col-span-2 text-indigo-700 border-indigo-200 hover:bg-indigo-50 flex gap-1.5 items-center justify-center normal-case text-xs font-bold py-1.5"
              >
                <Icon className="text-sm">all_inclusive</Icon> Descargar Todo
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
